import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Cloud = (props: IIcon) => {
  const { className = '', ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-6 h-6', className)}
      xmlns="http://www.w3.org/2000/svg"
      width={127}
      height={57}
      viewBox="0 0 127 57"
      fill="none"
    >
      <path
        d="M116.201 17.6596C115.423 17.6596 114.646 17.7707 113.869 17.8817C114.646 16.7711 115.09 15.4383 115.09 13.9944C115.09 10.2181 112.091 7.21933 108.315 7.21933C106.094 7.21933 104.095 8.33 102.873 10.1071C100.985 4.22053 95.4315 0 88.8785 0C80.7707 0 74.2177 6.55293 74.2177 14.6608C74.2177 15.7715 74.3288 16.7711 74.5509 17.7707H73.6624C67.7759 17.7707 63 22.5465 63 28.4331C63 34.3196 67.7759 39.0955 73.6624 39.0955H116.09C121.976 39.0955 126.752 34.3196 126.752 28.4331C126.752 22.5465 122.087 17.6596 116.201 17.6596Z"
        fill="#F8F8F8"
      />
      <path
        d="M115.09 15.1048C115.201 14.7716 115.201 14.3274 115.201 13.8831C115.201 13.4388 115.201 12.9946 115.09 12.5503C114.868 13.5499 114.535 14.4384 113.98 15.2159C114.313 15.2159 114.646 15.2159 115.09 15.1048ZM116.201 36.4296H73.6624C68.2201 36.4296 63.6664 32.3202 63.1111 26.989C63.1111 27.4332 63 27.8775 63 28.3218C63 34.2083 67.7759 38.9842 73.6624 38.9842H116.09C121.976 38.9842 126.752 34.2083 126.752 28.3218C126.752 27.8775 126.752 27.4332 126.641 26.989C126.197 32.3202 121.643 36.4296 116.201 36.4296ZM74.5509 15.1048C74.4399 14.5495 74.3288 13.8831 74.3288 13.2167C74.3288 13.661 74.2177 14.1052 74.2177 14.5495V15.1048H74.5509Z"
        fill="#EDEDED"
      />
      <path
        d="M72.3943 27.0307C71.3364 27.0307 70.2784 27.1818 69.2205 27.333C70.2784 25.8216 70.883 24.008 70.883 22.0432C70.883 16.9045 66.8023 12.8239 61.6636 12.8239C58.6409 12.8239 55.9205 14.3352 54.258 16.7534C51.6886 8.74318 44.1318 3 35.2148 3C24.1818 3 15.2648 11.917 15.2648 22.95C15.2648 24.4614 15.4159 25.8216 15.7182 27.1818H14.5091C6.49886 27.1818 0 33.6807 0 41.6909C0 49.7011 6.49886 56.2 14.5091 56.2H72.2432C80.2534 56.2 86.7523 49.7011 86.7523 41.6909C86.7523 33.6807 80.4045 27.0307 72.3943 27.0307Z"
        fill="#F8F8F8"
      />
      <path
        d="M70.883 23.5543C71.0341 23.1009 71.0341 22.4963 71.0341 21.8918C71.0341 21.2872 71.0341 20.6827 70.883 20.0781C70.5807 21.4384 70.1273 22.6474 69.3716 23.7054C69.825 23.7054 70.2784 23.7054 70.883 23.5543ZM72.3943 52.5724H14.5091C7.10341 52.5724 0.906818 46.9804 0.151136 39.7259C0.151136 40.3304 0 40.9349 0 41.5395C0 49.5497 6.49886 56.0486 14.5091 56.0486H72.2432C80.2534 56.0486 86.7523 49.5497 86.7523 41.5395C86.7523 40.9349 86.7523 40.3304 86.6011 39.7259C85.9966 46.9804 79.8 52.5724 72.3943 52.5724ZM15.7182 23.5543C15.567 22.7986 15.4159 21.8918 15.4159 20.9849C15.4159 21.5895 15.2648 22.194 15.2648 22.7986V23.5543H15.7182Z"
        fill="#EDEDED"
      />
    </svg>
  );
};

export default Cloud;
